import React from 'react'

function App() {
  return(
    <>
      <div className="jumbotron jumbotron-fluid pb-0">
        <div className="container">
          <div className="row justify-content-around">
            <div className="col jumbotron-content align-self-center text-center">
              <h1>Archived Target Market Determinations</h1>
              <h4 className='pt-3'>View our previous versions of TMDs</h4>
            </div>
          </div>
        </div>
      </div>
      <div className="internal-page">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
               <div className="target-market">
                 <div className="faq-qn"><h5>2026</h5></div>
                  <ul>
                    <li>
                      <a href={"/FAQ/Archived/Mortgage-SMSF-Variable-2026.pdf"} target="_blank" rel="noopener noreferrer">
                        Mortgage - SMSF Variable
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/Mortgage-SMSF-Fixed-2026.pdf"} target="_blank" rel="noopener noreferrer">
                        Mortgage - SMSF Fixed
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/2026_BCS_Alt_Doc_Fixed.pdf"} target="_blank" rel="noopener noreferrer">
                        BCS Alt Doc Fixed
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/2026_BCS_Alt_Doc_Variable.pdf"} target="_blank" rel="noopener noreferrer">
                        BCS Alt Doc Variable
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/2026_BCS_Expat_Super_Saver_Fixed.pdf"} target="_blank" rel="noopener noreferrer">
                        BCS Expat Super Saver Fixed
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/2026_BCS_Expat_Super_Saver_Variable.pdf"} target="_blank" rel="noopener noreferrer">
                        BCS Expat Super Saver Variable
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/2026_BCS_Freedom_Fixed.pdf"} target="_blank" rel="noopener noreferrer">
                        BCS Freedom Fixed
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/2026_BCS_Freedom_Variable.pdf"} target="_blank" rel="noopener noreferrer">
                        BCS Freedom Variable
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/2026_BCS_Near_Prime_Variable.pdf"} target="_blank" rel="noopener noreferrer">
                        BCS Near Prime Variable
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/2026_BCS_Prime_Fixed_Rate.pdf"} target="_blank" rel="noopener noreferrer">
                        BCS Prime Fixed Rates
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/2026_BCS_Prime_Variable.pdf"} target="_blank" rel="noopener noreferrer">
                        BCS Prime Variable
                      </a>
                    </li>
                    <li>
                      <a href={"/FAQ/Archived/2026_BCS_Specialist_Variable_Rates.pdf"} target="_blank" rel="noopener noreferrer">
                        BCS Specialist Variable Rates
                      </a>
                    </li>
                  </ul>
                 <div className="faq-qn"><h5>2025</h5></div>
                 <ul>
                   <li>
                     <a href={"/FAQ/Archived/RES_Prime_Flex.pdf"} target="_blank" rel="noopener noreferrer">
                      RES Prime Flex
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/RES_Prime_Standard.pdf"} target="_blank" rel="noopener noreferrer">
                      RES Prime Standard
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/RES_Prime_Alt_Doc.pdf"} target="_blank" rel="noopener noreferrer">
                      RES Prime Alt Doc
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/RES_Prime_Quickstart.pdf"} target="_blank" rel="noopener noreferrer">
                      RES Prime Quickstart
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/RES_Prime_85_No_LMI.pdf"} target="_blank" rel="noopener noreferrer">
                      RES Prime 85 No LMI
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/RES_Specialist_Full_Doc.pdf"} target="_blank" rel="noopener noreferrer">
                      RES Specialist Full Doc
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/RES_Specialist_Alt_Doc.pdf"} target="_blank" rel="noopener noreferrer">
                      RES Specialist Alt Doc
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/Mortgage_SMSF_Variable_TMD_(2024.1)_February_2024.pdf"} target="_blank" rel="noopener noreferrer">
                      Mortgage - SMSF Variable
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/Mortgage_SMSF_Fixed_TMD_(2024.1)_February_2024.pdf"} target="_blank" rel="noopener noreferrer">
                      Mortgage - SMSF Fixed
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/Personal_Loan_Unsecured.pdf"} target="_blank" rel="noopener noreferrer">
                      Personal loan - Unsecured
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/BCS_Alt_Doc_Variable.pdf"} target="_blank" rel="noopener noreferrer">
                      BCS Alt Doc Variable
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/BCS_Alt_Doc_Fixed.pdf"} target="_blank" rel="noopener noreferrer">
                      BCS Alt Doc Fixed
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/BCS_Prime_Variable.pdf"} target="_blank" rel="noopener noreferrer">
                      BCS Prime Variable
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Archived/BCS_Prime_Fixed_Rates.pdf"} target="_blank" rel="noopener noreferrer">
                      BCS Prime Fixed
                     </a>
                   </li>

                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Standard.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Standard
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Alt_Doc.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Alt Doc
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Flex.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Flex
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Flex_3_Years_Fixed.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Flex 3 Years Fixed
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Specialist_Full_Doc.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Specialist Full Doc
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Specialist_Full_Alt_Doc.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Specialist Alt Doc
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_85_No_LMI.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime 85 No LMI
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Quickstart.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Quickstart
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/BCS_Prime.pdf"} target="_blank" rel="noopener noreferrer">
                       BCS Prime
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/BCS_Alt_Doc.pdf"} target="_blank" rel="noopener noreferrer">
                       BCS Alt Doc
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/BCS_Near_Prime.pdf"} target="_blank" rel="noopener noreferrer">
                       BCS Near Prime
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/BCS_Specialist.pdf"} target="_blank" rel="noopener noreferrer">
                       BCS Specialist
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/BCS_Specialist_Plus.pdf"} target="_blank" rel="noopener noreferrer">
                       BCS Specialist Plus
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/BCS_SMSF_Residential.pdf"} target="_blank" rel="noopener noreferrer">
                       BCS SMSF Residential
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/BCS_Near_Prime_SMSF_Residential.pdf"} target="_blank" rel="noopener noreferrer">
                       BCS Near Prime SMSF Residential
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/BCS_SMSF_Commercial.pdf"} target="_blank" rel="noopener noreferrer">
                       BCS SMSF Commercial
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/BCS_Expat_Super_Saver.pdf"} target="_blank" rel="noopener noreferrer">
                       BCS Expat Super Saver
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/BCS_Freedom.pdf"} target="_blank" rel="noopener noreferrer">
                       BCS Freedom
                     </a>
                   </li>
                 </ul>
                 <div className="faq-qn"><h5>2024</h5></div>
                 <ul>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ//Mortgage_Ultra_Prime.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Ultra Prime
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Plus.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Plus
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Flex.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Flex
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Mere_Doc.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime (Mere Doc)
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Advantage-Essentials.pdf"} target="_blank" rel="noopener noreferrer">
                       Advantage Essentials
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Advantage-Special.pdf"} target="_blank" rel="noopener noreferrer">
                       Advantage Special
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Advantage-Special.pdf"} target="_blank" rel="noopener noreferrer">
                       Advantage Standard
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Prime_Variable_Product_TMD_2022.1.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Variable June 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Prime_Fixed_Product_TMD_2022.1.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage – Prime Fixed June 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/SMSF_Variable_Product_TMD_2022.1.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - SMSF Variable December June 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/SMSF_Fixed_Product_TMD_2022.1.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - SMSF Fixed December 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Prime_NDIS_Owner_Occupied_Variable_Product_TMD_2022.1.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime NDIS Variable 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Prime_NDIS_Owner_Occupied_Fixed_Product_TMD_2022.1.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime NDIS Fixed June 2022
                     </a>
                   </li>
                 </ul>
                 <div className="faq-qn"><h5>2022</h5></div>
                 <ul>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Standard_November_2022.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Standard November 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Horizon_November_2022.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage – Prime Horizon November 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Horizon_3_Years_Fixed_November_2022.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Horizon 3 Years Fixed November 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Alt_Doc_November_2022.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Alt Doc November 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Specialist_Full_Doc_November_2022.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Specialist Full Doc November 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Specialist_Alt_Doc_November_2022.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Specialist Alt Doc November 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_85_No_LMI_November_2022.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - 85 No LMI November 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Non_Gen_95_November_2022.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Non Gen 95 November 2022
                     </a>
                   </li>
                   <li>
                     <a href={"/FAQ/Mortgage_Prime_Quickstart_November_2022.pdf"} target="_blank" rel="noopener noreferrer">
                       Mortgage - Prime Quickstart November 2022
                     </a>
                   </li>
                 </ul>
               </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default App
